import { render, staticRenderFns } from "./CookieSetup.vue?vue&type=template&id=16f30d75"
import script from "./CookieSetup.vue?vue&type=script&lang=js"
export * from "./CookieSetup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports